import Cookies from 'js-cookie';

import { EMBED_SESSION_STORAGE_KEY, EMBED_VID_STORAGE_KEY } from '@/helpers/embed';
import { SESSION_HEADER_KEY, SESSION_KEY, VID_KEY } from '@/helpers/meta';

type EmbedClientIdentity = { sessionId: string; vid: string };

// In-memory ambient identity for cookieless embed when sessionStorage throws (Safari third-party iframe)
let embedClientIdentity: EmbedClientIdentity | null = null;

export const setEmbedClientIdentity = (identity: EmbedClientIdentity | null): void => {
  embedClientIdentity = identity;
};

const readEmbedStorage = (key: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getVid = (): string | null =>
  embedClientIdentity?.vid ?? readEmbedStorage(EMBED_VID_STORAGE_KEY) ?? Cookies.get(VID_KEY) ?? null;

export const getSessionId = (): string | null =>
  embedClientIdentity?.sessionId ?? readEmbedStorage(EMBED_SESSION_STORAGE_KEY) ?? Cookies.get(SESSION_KEY) ?? null;

export const getApiHeaders = (): Record<string, string> => {
  const session = getSessionId();

  return session
    ? { 'Content-Type': 'application/json', [SESSION_HEADER_KEY]: session }
    : { 'Content-Type': 'application/json' };
};
